import { render, staticRenderFns } from "./CmfPickupStep6.vue?vue&type=template&id=2cad8854&scoped=true"
import script from "./CmfPickupStep6.vue?vue&type=script&lang=js"
export * from "./CmfPickupStep6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cad8854",
  null
  
)

export default component.exports